import {Cache} from 'aws-amplify/utils';
import JwtDecode from 'jwt-decode';




export const getAuthorizationHeader = async () => {
    try {
        // let currentSession = await Auth.currentSession();
        // return currentSession.getIdToken().getJwtToken();

        const lastKey = await Cache.getItem('last-key');
        // if (lastKey !== null) {}

        console.debug(lastKey);
        const userTokens = await Cache.getItem(lastKey);

        const parsed = JSON.parse(userTokens);

        console.debug('ID TOKEN IN CONFIG IS: ', parsed.idToken);
        const userData = JwtDecode(parsed.idToken);
        console.debug('USER DATA IN CONFIG IS: ', userData);

        return parsed.idToken.toString();
    } catch (e) {
        console.error(e);
    }
}

// const FlexiEbooksApiKey = 'cxzjrROctt42mBKV8QJXK2t2kvymQozF3ShPMXmU';


const apiEndpoints = {}

export const config = apiEndpoints
